export default window._cmsContent['solar/electricity-usage']